export const NAVBAR_MENU_DEFAULTS = {
  padding: '0px',
  margin: '0px',
  overflow: 'hidden',
  borderRadius: '0px',
  borderBorderWidth: '1px',
  borderBorderStyle: 'solid',
  borderBorderColor: '#E4E7EC',
  defaultBoxShadow: 'none',
  borderBoxShadow: 'none',
  gap: '16px',
  shadowBoxShadow: '0px 4px 12px -2px rgba(0, 0, 0, 0.05), 0px 4px 12px -2px rgba(0, 0, 0, 0.07)',
  background: 'white',
  width: '100%',
  stickToTop: false,
  blurBackground: 0,
  stickyIsland: false,
  // Sticky defaults
  stickyBlurBackground: '0px',
  stickyBlurOpacity: '30',
  stickyPadding: '16px',
  stickyMaxWidth: '100%',
  stickyBorderRadius: '0px',
};
